import { ChevronRight } from 'lucide-react';

import { cn } from '@/lib/utils';

import type { MonthlyRecapsArticle } from '@/features/monthly-recaps';

type MonthlyRecapsArticleTeaserVariant = 'row' | 'single';

type MonthlyRecapsArticleTeaserProps = {
  article: MonthlyRecapsArticle;
  onClick: () => void;
  variant?: MonthlyRecapsArticleTeaserVariant;
};

const DESCRIPTION_CHAR_LIMIT = 240;

const truncateDescription = (description: string): string =>
  description.length > DESCRIPTION_CHAR_LIMIT
    ? `${description.slice(0, DESCRIPTION_CHAR_LIMIT)}...`
    : description;

export const MonthlyRecapsArticleTeaser = ({
  article,
  onClick,
  variant = 'row'
}: MonthlyRecapsArticleTeaserProps) => (
  <div
    className={cn(
      'flex w-full flex-col items-start gap-1 text-left',
      variant === 'row' ? 'bg-gx-tile-light p-2' : 'px-4 pb-4'
    )}
  >
    <p className={cn('mb-1 font-bold', variant === 'single' ? 'text-2xl' : 'text-sm')}>
      {article.headline}
    </p>
    <p className={cn(variant === 'single' ? 'text-base' : 'text-sm')}>
      {variant === 'single' ? article.description : truncateDescription(article.description)}{' '}
      <button
        className='inline-flex items-center align-baseline text-sm text-primary no-underline'
        type='button'
        onClick={onClick}
      >
        Read full article
        <ChevronRight className='size-[1em]' />
      </button>
    </p>

    <p className='text-xs font-medium text-gx-subtext'>Date: {article.date}</p>
  </div>
);
